import React, { useState } from 'react';
import { ChevronDown, Check } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function KitContents() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const tomos = [{
    title: 'TOMO 1 — FUNDAMENTOS',
    items: ['Reconocimiento del teclado', 'Postura y técnica básica', 'Ubicación de notas', 'Ejercicios iniciales', 'Primeras melodías', 'Lectura básica'],
    highlight: 'Para arrancar desde cero con claridad'
  }, {
    title: 'TOMO 2 — RITMO Y COORDINACIÓN',
    items: ['Independencia de manos', 'Trabajo de ritmo y tempo', 'Uso del metrónomo', 'Ejercicios progresivos', 'Coordinación aplicada'],
    highlight: 'Para que el alumno gane seguridad real'
  }, {
    title: 'TOMO 3 — ACORDES',
    items: ['Acordes mayores y menores', 'Inversiones', 'Progresiones', 'Acompañamientos', 'Aplicación en canciones'],
    highlight: 'Donde el alumno empieza a disfrutar tocar'
  }, {
    title: 'TOMO 4 — LECTURA Y TÉCNICA',
    items: ['Lectura musical', 'Escalas', 'Técnica de dedos', 'Dinámica', 'Ejercicios técnicos'],
    highlight: 'Para subir el nivel del alumno'
  }, {
    title: 'TOMO 5 — REPERTORIO',
    items: ['Canciones por nivel', 'Adaptaciones simples', 'Ejecución guiada', 'Interpretación', 'Actividades prácticas'],
    highlight: 'Clases más dinámicas y entretenidas'
  }, {
    title: 'TOMO 6 — CREATIVIDAD',
    items: ['Improvisación', 'Composición básica', 'Exploración musical', 'Actividades creativas'],
    highlight: 'Para formar músicos completos'
  }];
  return <section className="bg-[#050a1a] py-4 md:py-6 px-3" data-id="element-65">
      <div className="max-w-2xl mx-auto" data-id="element-66">
        <h2 className="text-2xl md:text-3xl font-black text-white text-center mb-1" data-id="element-67">
          📖 QUÉ RECIBÍS
        </h2>
        <p className="text-[#2563eb] text-center text-xs font-bold mb-4" data-id="element-68">
          (CON ÍNDICE REAL)
        </p>

        <div className="space-y-2 mb-4" data-id="element-69">
          {tomos.map((tomo, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="bg-[#0a1128] border border-[#1e293b] rounded-lg overflow-hidden" data-id="element-70">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between p-3 text-left hover:bg-[#0f172a] transition-colors" data-id="element-71">
                  <span className="font-black text-white text-sm md:text-base flex items-center gap-2" data-id="element-72">
                    <span className="text-[#2563eb]" data-id="element-73">🎼</span> {tomo.title}
                  </span>
                  <motion.div animate={{
                rotate: isOpen ? 180 : 0
              }} data-id="element-74">
                    <ChevronDown className="w-4 h-4 text-[#2563eb]" data-id="element-75" />
                  </motion.div>
                </button>

                <AnimatePresence data-id="element-76">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} className="overflow-hidden" data-id="element-77">
                      <div className="px-3 pb-3 border-t border-[#1e293b]" data-id="element-78">
                        <ul className="grid grid-cols-1 md:grid-cols-2 gap-1 mt-2 mb-2" data-id="element-79">
                          {tomo.items.map((item, i) => <li key={i} className="flex items-start gap-1.5 text-gray-300 text-xs md:text-sm" data-id="element-80">
                              <Check className="w-3.5 h-3.5 text-[#2563eb] flex-shrink-0 mt-0.5" data-id="element-81" />
                              <span data-id="element-82">{item}</span>
                            </li>)}
                        </ul>
                        <div className="bg-[#2563eb]/10 border border-[#2563eb]/30 rounded p-2 text-center" data-id="element-83">
                          <p className="text-[#eab308] font-bold text-xs" data-id="element-84">
                            👉 {tomo.highlight}
                          </p>
                        </div>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <div className="text-center bg-[#0a1128] border border-[#1e293b] rounded-xl p-3 glow-blue" data-id="element-85">
          <p className="text-base md:text-lg font-black text-white mb-1" data-id="element-86">
            🔥 Todo paso a paso, listo para aplicar.
          </p>
          <p className="text-sm font-bold text-[#eab308]" data-id="element-87">
            👉 Entrás a clase con todo resuelto.
          </p>
        </div>
      </div>
    </section>;
}